import {
  useSelectedValueByVariableKey,
  useSelectionByVariableKey,
} from '@k3/core'
import { useBounds } from '@react-three/drei'
import { Connect7 } from '../mesh/Connect7'
import { TwinBoxes } from '../mesh/TwinBoxes'
import { isEFormClearType, Keys } from '../utility/utils'
import { Suspense, useEffect, useRef } from 'react'
import { BackGlassPanel } from './BackGlassPanel'
import { FrontGlassPanel } from './FrontGlassPanel'
import { SolarPanels } from './SolarPanels'
import { Group, Object3D } from 'three'

export const SunovationPanel = ({
  onMounted,
}: {
  onMounted: (isMounted: boolean) => void
}) => {
  const ref = useRef<Group>(null)
  const bounds = useBounds()
  const isEFormClear = isEFormClearType(
    useSelectedValueByVariableKey(Keys.EFormType.Variable)
  )
  const width = useSelectionByVariableKey('length')
  const height = useSelectionByVariableKey('width')

  useEffect(() => {
    // setTimeout cares about next rendering when components size can be calulated
    setTimeout(() => {
      bounds.refresh(ref.current as Object3D).fit()
      onMounted(true)
    })
  }, [width?.data?.inputValue, height?.data?.inputValue, ref])

  return (
    <Suspense fallback={null}>
      <group name="panel" ref={ref}>
        {!isEFormClear && <TwinBoxes />}
        {isEFormClear && <Connect7 />}
        <FrontGlassPanel />
        <SolarPanels />
        <BackGlassPanel />
      </group>
    </Suspense>
  )
}
